var _ellipse, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGamyFiMonochrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4548,
    cy: 38.5,
    rx: 22.4548,
    ry: 22.5,
    fill: "#0C2C54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2176_42331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4182 38.2812C43.9801 36.7008 41.6068 35.4276 40.4749 34.9886C40.767 34.6959 41.5484 34.0666 42.337 33.891C43.3228 33.6715 44.0896 33.891 45.0754 34.1105C46.0612 34.33 45.5136 34.1105 46.2803 34.1105C47.0471 34.1105 47.7043 33.891 49.6759 34.9886C51.6476 36.0861 52.4143 38.5008 52.7429 39.3788C53.0715 40.2569 53.7287 42.7812 53.1811 45.7447C52.7429 48.1154 51.9762 49.6593 51.6476 50.1349C51.7936 49.1471 51.9981 47.3032 51.6476 47.83C51.2094 48.4886 49.1282 50.3544 47.5947 51.3422C46.0612 52.33 41.8989 53.4276 39.0509 53.2081C36.7726 53.0325 34.0146 52.0001 33.1018 51.561C33.5765 51.561 34.8544 51.2757 35.7307 51.0123C36.826 50.683 37.8118 50.5732 39.674 49.3659C41.1636 48.4001 42.4854 47.1708 43.0696 46.4025L41.5361 46.183C41.9742 45.8171 43.4324 44.4495 43.8705 43.6593C44.4182 42.6715 44.9659 40.2569 44.4182 38.2812Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2176_42331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3834 35.7568C31.8216 29.6983 36.8237 25.4032 39.27 24.0129C38.4302 24.0861 36.4659 24.3203 35.3267 24.6715C33.9028 25.1105 31.3834 26.6471 29.6309 28.2934C27.8783 29.9398 26.1257 33.3422 25.6876 36.3056C25.2494 39.269 25.7971 42.6715 27.5497 46.1837C28.9517 48.9934 31.8581 50.9398 33.136 51.5617C33.3551 51.5983 33.7056 51.5398 34.6695 51.452C35.8744 51.3422 38.3937 50.5739 39.7081 49.6959C41.0124 48.8246 42.6291 47.0617 43.2133 46.1837C43.1768 46.2203 43.038 46.3373 42.7751 46.5129C42.4465 46.7325 41.1321 47.391 40.3653 47.391C39.5986 47.391 38.3937 47.391 36.7507 46.7325C35.1076 46.0739 30.8357 43.33 31.3834 35.7568Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2176_42331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4788 32.2447C31.8654 34.0008 31.566 36.635 31.493 37.7326C31.5309 37.3301 31.8469 36.1081 32.8074 34.4399C34.008 32.3545 36.3126 30.9277 38.3937 30.3789C40.4749 29.8301 44.4182 29.8301 48.3615 30.3789C52.3048 30.9277 52.4143 32.6838 52.1953 31.8057C51.9762 30.9277 51.538 29.1716 50.1141 27.196C48.6901 25.2203 47.0471 24.5618 45.7326 24.3423C44.7837 24.1838 41.9462 23.9382 39.9272 24.3423C39.051 24.5177 38.4002 25.1165 38.0651 25.3301C36.0133 26.6384 33.2456 30.0496 32.4788 32.2447Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2176_42331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5883 33.7813C31.7579 35.4455 31.566 36.635 31.493 37.7326C31.5309 37.3301 31.8469 36.1082 32.8074 34.4399C34.008 32.3545 36.3126 30.9277 38.3937 30.3789C40.4749 29.8301 44.4182 29.8301 48.3615 30.3789C52.3048 30.9277 52.4143 32.6838 52.1953 31.8057C51.9762 30.9277 51.6476 29.3911 50.2236 27.4155C47.7043 26.8667 46.0794 26.8667 44.7469 26.8667H44.7468C42.5561 26.8667 41.2965 27.0862 39.5986 27.7448C36.203 29.0618 33.6837 31.5862 32.5883 33.7813Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2176_42331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6476 50.1349C51.7936 49.1471 51.8666 48.269 51.8666 47.83C51.9397 46.6959 51.9543 44.0325 51.4285 42.452C50.9027 40.8715 50.4062 40.2568 50.2236 40.1471C50.3331 40.952 50.3112 42.9788 49.3473 44.6471C49.2378 44.0983 49.2378 40.5861 48.3615 39.0495C47.6605 37.8203 47.8138 38.0617 47.5947 37.7325C47.4852 37.6227 47.7043 39.7081 47.3757 40.3666C47.2661 39.7812 46.9156 38.4349 46.3898 37.7325C45.7326 36.8544 44.6373 35.4276 43.2133 35.0983C42.0741 34.8349 40.9131 34.9154 40.4749 34.9886C40.767 34.6959 41.5484 34.0666 42.337 33.891C43.3228 33.6715 44.0896 33.891 45.0754 34.1105C46.0612 34.33 45.5136 34.1105 46.2803 34.1105C47.0471 34.1105 47.7043 33.891 49.6759 34.9886C51.6476 36.0861 52.4143 38.5008 52.7429 39.3788C53.0715 40.2569 53.7288 42.7812 53.1811 45.7447C52.7429 48.1154 51.9762 49.6593 51.6476 50.1349Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7184 36.3056V34.9885L49.3473 36.0861L46.7184 36.3056Z",
    fill: "#0C2C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5989 43.2867C87.9477 44.0682 87.027 44.6765 85.837 45.1116C84.647 45.5386 83.3284 45.7521 81.8811 45.7521C80.3615 45.7521 79.0268 45.4218 77.877 44.7611C76.7352 44.0924 75.8508 43.1256 75.2236 41.8607C74.6045 40.5958 74.2869 39.1094 74.2708 37.4014V36.205C74.2708 34.4486 74.5643 32.9299 75.1512 31.6489C75.7462 30.3599 76.5985 29.377 77.7081 28.7002C78.8257 28.0154 80.1323 27.673 81.6278 27.673C83.7103 27.673 85.3385 28.1725 86.5124 29.1715C87.6863 30.1625 88.3818 31.6086 88.5989 33.51H85.0772C84.9164 32.5029 84.5586 31.7657 84.0038 31.2985C83.457 30.8312 82.7012 30.5975 81.7364 30.5975C80.5062 30.5975 79.5695 31.0608 78.9262 31.9873C78.283 32.9138 77.9574 34.2915 77.9493 36.1204V37.2443C77.9493 39.0892 78.2991 40.483 78.9986 41.4257C79.6981 42.3683 80.7233 42.8396 82.0741 42.8396C83.4329 42.8396 84.4018 42.5496 84.9807 41.9695V38.9362H81.6881V36.2654H88.5989V43.2867Z",
    fill: "#0C2C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1217 45.5104C98.9608 45.1962 98.8443 44.8054 98.7719 44.3381C97.9276 45.2808 96.8301 45.7521 95.4793 45.7521C94.2009 45.7521 93.1395 45.3815 92.2953 44.6403C91.4591 43.899 91.041 42.9645 91.041 41.8365C91.041 40.4508 91.5516 39.3873 92.5727 38.6461C93.6019 37.9049 95.0853 37.5303 97.0231 37.5222H98.6272V36.7729C98.6272 36.1687 98.4704 35.6853 98.1568 35.3228C97.8513 34.9602 97.3648 34.7789 96.6975 34.7789C96.1105 34.7789 95.6482 34.9199 95.3105 35.2019C94.9808 35.4839 94.816 35.8706 94.816 36.3621H91.3304C91.3304 35.6047 91.5636 34.9038 92.03 34.2593C92.4963 33.6147 93.1556 33.1112 94.0079 32.7487C94.8602 32.3781 95.817 32.1927 96.8784 32.1927C98.4865 32.1927 99.7609 32.5996 100.702 33.4133C101.65 34.219 102.125 35.355 102.125 36.8213V42.4891C102.133 43.7299 102.306 44.6685 102.643 45.3049V45.5104H99.1217ZM96.2391 43.0813C96.7537 43.0813 97.2281 42.9685 97.6623 42.7429C98.0965 42.5093 98.4181 42.1991 98.6272 41.8124V39.5646H97.3246C95.5798 39.5646 94.6512 40.1688 94.5386 41.3773L94.5265 41.5828C94.5265 42.0178 94.6793 42.3763 94.9848 42.6583C95.2904 42.9403 95.7085 43.0813 96.2391 43.0813Z",
    fill: "#0C2C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.318 32.4344L108.426 33.8967C109.351 32.7607 110.601 32.1927 112.177 32.1927C113.858 32.1927 115.011 32.8574 115.639 34.1868C116.555 32.8574 117.862 32.1927 119.558 32.1927C120.973 32.1927 122.027 32.6077 122.718 33.4375C123.41 34.2593 123.755 35.5 123.755 37.1597V45.5104H120.258V37.1718C120.258 36.4305 120.113 35.8907 119.824 35.5524C119.534 35.2059 119.024 35.0327 118.292 35.0327C117.247 35.0327 116.523 35.5322 116.121 36.5312L116.133 45.5104H112.647V37.1838C112.647 36.4265 112.499 35.8787 112.201 35.5403C111.904 35.2019 111.397 35.0327 110.682 35.0327C109.693 35.0327 108.977 35.4436 108.535 36.2654V45.5104H105.049V32.4344H108.318Z",
    fill: "#0C2C54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.564 40.5676L133.977 32.4344H137.715L132.469 47.5406L132.18 48.2295C131.4 49.9375 130.113 50.7915 128.32 50.7915C127.814 50.7915 127.299 50.715 126.776 50.5619V47.9153L127.307 47.9274C127.966 47.9274 128.457 47.8267 128.778 47.6252C129.108 47.4238 129.365 47.0895 129.55 46.6222L129.96 45.5466L125.389 32.4344H129.14L131.564 40.5676Z",
    fill: "#0C2C54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.132 38.3198H143.185V45.5104H139.567V27.9147H151V30.8513H143.185V35.3953H150.132V38.3198Z",
    fill: "#0C2C54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.795 45.5104H153.297V32.4344H156.795V45.5104ZM153.092 29.0507C153.092 28.527 153.265 28.0959 153.611 27.7576C153.965 27.4192 154.443 27.25 155.046 27.25C155.641 27.25 156.116 27.4192 156.469 27.7576C156.823 28.0959 157 28.527 157 29.0507C157 29.5824 156.819 30.0175 156.457 30.3558C156.103 30.6942 155.633 30.8634 155.046 30.8634C154.459 30.8634 153.985 30.6942 153.623 30.3558C153.269 30.0175 153.092 29.5824 153.092 29.0507Z",
    fill: "#0C2C54"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2176_42331",
    x: 30.1018,
    y: 31.8,
    width: 26.2896,
    height: 25.4363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2176_42331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2176_42331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2176_42331",
    x: 23.5438,
    y: 22.0129,
    width: 23.6694,
    height: 33.5598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2176_42331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2176_42331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2176_42331",
    x: 28.493,
    y: 22.1221,
    width: 26.7683,
    height: 19.6106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2176_42331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2176_42331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2176_42331",
    x: 28.493,
    y: 24.8667,
    width: 26.7683,
    height: 16.866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2176_42331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2176_42331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2176_42331",
    x: 37.4749,
    y: 31.8,
    width: 18.9165,
    height: 22.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2176_42331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2176_42331",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamyFiMonochrome);
export default __webpack_public_path__ + "static/media/gamyFiMonochrome.f7484f1098c2675d3f4f346c3e336b69.svg";
export { ForwardRef as ReactComponent };